import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { getControlsBarStyleObject } from './controlsBar.style';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { Volume } from './volume/volume';
import { CurrentTimeAndDuration } from './currentTimeAndDuration/currentTimeAndDuration';
import { SkipVideoButton } from './skipVideoButton/skipVideoButton';
import { FullscreenButton } from './fullScreenButton/fullScreenButton';
import { PlayPauseButton } from './playPauseButton/playPauseButton';
import { VoltaxLogo } from './voltaxLogo/voltaxLogo';
import { getBottomBarId } from '../htmlElements/htmlElementsIdGetter';
import { css } from '../../../common/styles/styles.utils';
import { adsDataSelector } from '../../../common/store/selectors/adsData.selector';
import { ClosedCaptionsButton } from './closedCaptionsButton/ClosedCaptionsButton';
import { videoDataSelector } from '../../../common/store/selectors/videoData.selector';
import { recirculationVideoDataSelector } from '../../../common/store/selectors/recirculationVideoData.selector';

export const ControlsBar: FunctionComponent = () => {
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const captions = useSelector(videoDataSelector.captions);
  const numberOfScenes = useSelector(recirculationVideoDataSelector.numberOfScenes);

  const showAdControls = isVastAd && adBreak;
  const recirculationVideoControls = numberOfScenes !== 0 && !showAdControls;
  const shouldShowCaptions = typeof captions === 'string' && !adBreak;

  const styles = getControlsBarStyleObject(recirculationVideoControls);
  const { controlsBarStyle, rightControlsStyle, leftControlsStyle } = styles;

  return (
    <div style={css(controlsBarStyle as any[])} id={getBottomBarId(playerUniqueId)}>
      <div style={leftControlsStyle}>
        <PlayPauseButton />
        <SkipVideoButton />
        <CurrentTimeAndDuration />
      </div>
      <div style={rightControlsStyle}>
        <Volume />
        {shouldShowCaptions && <ClosedCaptionsButton />}
        <VoltaxLogo />
        <FullscreenButton />
      </div>
    </div>
  );
};
